import moment from 'moment';

export default class PaymentModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.status = data.status || '';
    this.description = data.description || '';

    this.amount_due_cents = data.amount_due_cents || 0;
    this.can_pay_with_group_credit = data.can_pay_with_group_credit || false;
    this.can_pay_with_individual_session_credit = data.can_pay_with_individual_session_credit || false;
    this.credit_used = !!data.credit_used;

    this.paid_on_date = data.paid_on_date ? moment(data.paid_on_date).toDate() : null;
    this.created = data.created ? moment(data.created).toDate() : null;
    this.due_date = data.due_date ? moment(data.due_date).toDate() : null;
    this.appointment_date = data.appointment_date ? moment(data.appointment_date).toDate() : null;

  }

  get statusStr() {
    if (this.status === 'pending') {
      return 'Not Paid';
    } else if (this.status === 'paid') {
      return 'Paid';
    }

    return this.status; // todo:
  }

  get stripeSuccessUrl() {
    return `${document.location.origin}/stripe/payment/${this.id}/success`;
  }
  get stripeErrorUrl() {
    return `${document.location.origin}/stripe/payment/${this.id}/error`;
  }
}
